import React, { useState, useEffect, useCallback } from 'react';

import { NotifyModal } from 'components';
import { DIALOG_KINDS } from 'constants/dialogKinds';

import { useDeleteLocation } from '../../../../../hooks';
import styles from './styles.scss';

const DeleteLocationModal = ({
  toggleModal,
  isModalOpen,
  location,
  deleteAction,
}) => {
  const [isLoading, setIsLoading] = useState(false);
  const [isReadyToDelete, setIsReadyToDelete] = useState(false);
  const [modalConfirmText, setModalConfirmText] = useState('');
  const [modalTitleText, setModalTitleText] = useState('');

  const deleteLocationMutation = useDeleteLocation(location?.locationId);

  useEffect(() => {
    const checkDelete =
      location && location.userCount === 0 && !location.defaultLocation;

    setIsReadyToDelete(checkDelete);
    setModalConfirmText(checkDelete ? 'Yes, delete' : 'Close');
    setModalTitleText(
      checkDelete ? 'Delete location?' : "Can't delete location",
    );
  }, [location]);

  const onConfirm = useCallback(() => {
    if (isReadyToDelete) {
      if (!isLoading) {
        setIsLoading(true);

        deleteAction(deleteLocationMutation.mutate).then(() => {
          setIsLoading(false);
        });
      }
    } else {
      toggleModal();
    }
  }, [isReadyToDelete, isModalOpen]);

  return (
    <NotifyModal
      title={modalTitleText}
      confirmText={modalConfirmText}
      onCancel={toggleModal}
      hasCancel={isReadyToDelete}
      onConfirm={onConfirm}
      mode={DIALOG_KINDS.ERROR}
      open={isModalOpen}
      isLoading={isLoading}
    >
      <div className={styles.modalBody}>
        {isReadyToDelete ? (
          <div
            className={styles.modalBody__main}
            data-testid="PlatformAdminUI-Locations-DeleteLocationModal-Body"
          >
            You are about to delete{' '}
            <b>{location ? location.locationName : null}</b> from your{' '}
            <b>Account Information</b>. <br /> <br />
            Don&apos;t worry, you can always add it again if you need to.
          </div>
        ) : (
          <div>
            <ul className={styles.modalBody__list}>
              {location?.defaultLocation && (
                <li>
                  <div className={styles.modalBody__main}>
                    You cannot delete the default location <br />
                  </div>
                </li>
              )}
              {location?.userCount > 0 && (
                <li>
                  <div className={styles.modalBody__main}>
                    It looks like the <b>{location.locationName}</b> location
                    has <b>{location.userCount}</b> users in it. <br />
                  </div>
                </li>
              )}
            </ul>
            <div className={styles.modalBody__main}>
              Please contact Nextiva Support for assistance.
            </div>
          </div>
        )}
      </div>
    </NotifyModal>
  );
};

export default DeleteLocationModal;
